import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
// import { withStyles } from '@material-ui/core/styles';
// import cx from 'clsx';

// const styles = theme => ({
// });

const AfitdLinearProgress = props => {
    const { className, isHidden, children, ...otherProps } = props;

    return isHidden ? null : <LinearProgress {...otherProps} />;
};

export default AfitdLinearProgress;
// export default withStyles(styles)(AfitdFab);
